import React from "react";
import { Box, Grid, Chip } from "@mui/material";
import {
  InfoOutlined,
  ManageAccountsOutlined,
  DateRangeOutlined,
  Directions,
} from "@mui/icons-material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { localizeDateTimeShort } from "utils/dateFormats";
import { useLocalTransportRuleDetailContext } from "contexts/LocalTransportRuleDetailContext";

const getAutoApproveStyle = (autoApprove) => {
  return autoApprove
    ? { backgroundColor: "#D4EDDA", textColor: "#155724" }
    : { backgroundColor: "#F8D7DA", textColor: "#721C24" };
};

const LocalTransportRuleBasicDetail = () => {
  const { ruleDetail, loadingRule } = useLocalTransportRuleDetailContext();

  return !loadingRule ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="From Branch"
            subtitle={
              ruleDetail?.branch?.length > 0
                ? ruleDetail.branch.map(b => b.name).join(", ")
                : "All Branches"
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="To Branch"
            subtitle={
              ruleDetail?.toBranch?.length > 0
                ? ruleDetail.toBranch.map(b => b.name).join(", ")
                : "All Branches"
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Mode"
            subtitle={ruleDetail?.transportationMode?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Max Distance (km)"
            subtitle={ruleDetail?.maxDistanceKm || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Max Cost"
            subtitle={
              ruleDetail?.maxCost ? `₹${ruleDetail.maxCost}` : "Unlimited"
            }
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Price per Sack (₹)"
            subtitle={ruleDetail?.pricePerSack || "N/A"}
          />
        </Grid>
        {/* add bidirectional if exist true */}
        {ruleDetail?.isBidirectional && (
          <Grid item xs={3}>
            <InformationTile
              icon={() => <Directions color="primary" />}
              title="Bidirectional"
              color="primary"
              subtitle={ruleDetail?.isBidirectional ? "Bidirectional" : ""}
            />
          </Grid>
        )}

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Auto Approve"
            subtitle={
              <Box
                display="flex"
                flexDirection="column"
                alignItems="start"
                mt={1}
              >
                <Chip
                  label={ruleDetail?.autoApprove ? "Yes" : "No"}
                  style={{
                    backgroundColor: getAutoApproveStyle(
                      ruleDetail?.autoApprove
                    ).backgroundColor,
                    color: getAutoApproveStyle(ruleDetail?.autoApprove)
                      .textColor,
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    fontSize: "0.7rem",
                    height: "20px",
                    padding: "0 6px",
                    borderRadius: "12px",
                    marginTop: "4px",
                  }}
                />
              </Box>
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <ManageAccountsOutlined color="primary" />}
            title="Created By"
            subtitle={ruleDetail?.createdBy?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <DateRangeOutlined color="primary" />}
            title="Created At"
            subtitle={
              ruleDetail?.createdAt
                ? localizeDateTimeShort(ruleDetail.createdAt)
                : "N/A"
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <DateRangeOutlined color="primary" />}
            title="Updated At"
            subtitle={
              ruleDetail?.updatedAt
                ? localizeDateTimeShort(ruleDetail.updatedAt)
                : "N/A"
            }
          />
        </Grid>

        <Grid item xs={12}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Description"
            subtitle={ruleDetail?.description || "No description"}
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default LocalTransportRuleBasicDetail;
